<template>
    <div class="options">
        <p class="text-answer">Getal</p>
    </div>
</template>

<script setup lang="ts">

</script>
